import React from 'react';
import { Counselor, User, UserRole } from '../../types';
import Button from '../ui/Button';
import { actionIcon } from '../ui/actionIcons';
import { WorkloadFilter } from './adminUtils';
import { t } from '../../utils/translations';
import AdminUserTable from './AdminUserTable';
import AdminRoleCards from './AdminRoleCards';
import CounselorsFilterTabs from '../Counselors/CounselorsFilterTabs';

interface AdminUsersPanelProps {
  users: User[];
  counselors: Counselor[];
  loading: boolean;
  canCreateUsers: boolean;
  currentUserId?: string;
  currentUserRole?: UserRole;
  isSupremeLeader: boolean;
  workloadFilter: WorkloadFilter;
  onWorkloadFilterChange: (value: WorkloadFilter) => void;
  workloadCounts: { all: number; low: number; moderate: number; high: number };
  onCreateUser: () => void;
  onEdit: (user: User) => void;
  onDeactivate: (userId: string) => void;
  onReactivate: (userId: string) => void;
  reactivatingUserId?: string | null;
  onDelete: (userId: string) => void;
  onTransferSupremeLeader: (userId: string) => void;
}

const AdminUsersPanel: React.FC<AdminUsersPanelProps> = ({
  users,
  counselors,
  loading,
  canCreateUsers,
  currentUserId,
  currentUserRole,
  isSupremeLeader,
  workloadFilter,
  onWorkloadFilterChange,
  workloadCounts,
  onCreateUser,
  onEdit,
  onDeactivate,
  onReactivate,
  reactivatingUserId = null,
  onDelete,
  onTransferSupremeLeader,
}) => (
  <div className="space-y-6">
    <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
      <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-base font-semibold text-slate-900">{t.adminTools.userManagement}</h2>
        </div>
        {canCreateUsers && (
          <Button variant="primary" icon={actionIcon.add} onClick={onCreateUser}>
            {t.admin.users.createUser}
          </Button>
        )}
      </div>

      <CounselorsFilterTabs
        activeFilter={workloadFilter}
        onFilterChange={onWorkloadFilterChange}
        counts={workloadCounts}
      />

      <AdminUserTable
        users={users}
        counselors={counselors}
        loading={loading}
        currentUserId={currentUserId}
        currentUserRole={currentUserRole}
        canCreateUsers={canCreateUsers}
        isSupremeLeader={isSupremeLeader}
        onEdit={onEdit}
        onDeactivate={onDeactivate}
        onReactivate={onReactivate}
        reactivatingUserId={reactivatingUserId}
        onDelete={onDelete}
        onTransferSupremeLeader={onTransferSupremeLeader}
      />
    </section>

    <AdminRoleCards />
  </div>
);

export default AdminUsersPanel;
